import { type RouteComponentProps, Switch, Route, useRouteMatch } from 'react-router-dom';

import TableOfContentsPage from '@editor2/containers/TableOfContentsPage';
import ChapterPage from '@editor2/containers/ChapterPage';
import PageGroupPage from '@editor2/containers/PageGroupPage';
import PageElementsPage from '@editor2/containers/PageElementsPage';

const Routing = () => {
	const { path } = useRouteMatch();

	return (
		<Switch>
			<Route
				exact
				path={`${path}/chapters/:chapterId/page_groups/:pageGroupId/pages/:pageId`}
				render={(props) => (
					<PageElementsPage {...(props as RouteComponentProps<any>)} key={props.location.key} />
				)}
			/>
			<Route
				exact
				path={`${path}/chapters/:chapterId/pages/:pageId`}
				render={(props) => (
					<PageElementsPage {...(props as RouteComponentProps<any>)} key={props.location.key} />
				)}
			/>
			<Route
				exact
				path={`${path}/chapters/:chapterId/page_groups/:pageGroupId`}
				render={(props) => (
					<PageGroupPage {...(props as RouteComponentProps<any>)} key={props.location.key} />
				)}
			/>
			<Route
				exact
				path={`${path}/chapters/:chapterId`}
				render={(props) => (
					<ChapterPage {...(props as RouteComponentProps<any>)} key={props.location.key} />
				)}
			/>
			<Route exact path={`${path}`} component={TableOfContentsPage} />
		</Switch>
	);
};

export default Routing;
